export function matches(str1 = "", str2 = "") {
    return str1?.toLowerCase().includes(str2?.toLowerCase().trim())
}
